import React from 'react'
import cls from 'classnames'
import { Box, Button, Group, Image, Stack, Text } from '@mantine/core'

import { ContentIntoView } from 'components/ui'
import { openCrisp } from 'plugins/crisp'
import { ContentContainer, SiteTitle } from 'components/site'
import avatarImg from 'assets/images/site/avatar/girl11.png'
import classes from './index.module.scss'

const ContactUs = () => {
  return (
    <ContentIntoView rootMargin="0px 0px -200px 0px">
      {(entry) => {
        const { isIntersecting } = entry || {}
        return (
          <ContentContainer className={classes.outer}>
            <Group className={classes.wrapper} position="apart">
              <Group spacing={16}>
                <Box className="w-[60px] h-[60px] sm:w-[100px] sm:h-[100px]">
                  <Image src={avatarImg.src} alt="avatar" />
                </Box>
                <Stack spacing={12}>
                  <SiteTitle text="不知道选择哪个套餐？" isIntersecting={isIntersecting} />
                  <Text
                    c="gray.7"
                    className={cls('text-[24px] transformSlideInBottomBase delay-150', {
                      transformSlideInBottom: isIntersecting,
                    })}
                  >
                    联系客户经理，我们会针对您的业务给予建议
                  </Text>
                </Stack>
              </Group>
              <Button radius="md" size="lg" className="self-end sm:w-[270px] w-[254px]" onClick={openCrisp}>
                联系客户经理
              </Button>
            </Group>
          </ContentContainer>
        )
      }}
    </ContentIntoView>
  )
}

export default ContactUs
